module.exports = __webpack_public_path__ + "img/tag-no.0e6ad040.png";